module.exports = __webpack_public_path__ + "static/img/baojingjiechu.b31f776.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/baojingjiechu.png
// module id = VC5S
// module chunks = 24